import { useCallback, useState } from 'react'

import { getErrorClientDevices } from '@/apis/clientDevice'
import { API_LIMIT } from '@/constants/api'
import useQueryPage from '@/hooks/useQueryPage'
import { GetErrorClientDeviceResponse, GetOneClientDeviceRequest } from '@/types/apis/clientDevice'

export const useDeviceError = () => {
  const currentPage = useQueryPage()
  const [page, setPage] = useState(currentPage)

  const [deviceErrorResponse, setDeviceErrorResponse] = useState<GetErrorClientDeviceResponse>()
  const [loading, setLoading] = useState(false)

  const getErrorDevice = useCallback(
    async (request: GetOneClientDeviceRequest) => {
      try {
        setLoading(true)
        const res = await getErrorClientDevices({ page, limit: API_LIMIT, date: request.date })
        setDeviceErrorResponse(res)
      } finally {
        setLoading(false)
      }
    },
    [page]
  )

  return {
    getErrorDevice,
    deviceErrorResponse,
    loading,
    page,
    pageSize: API_LIMIT,
    setPage,
  }
}
